export default "__VITE_ASSET__sn7BXUNn__"